const routes = [
  {
    text: "Dashboard",
    value: "Dashboard.vue",
  },
  {
    text: "GeneralNavigation",
    value: "GeneralNavigation.vue",
  },
  {
    text: "Add New User",
    value: "Settings/UserOperations/AddNewUser.vue",
  },
  {
    text: "Edit User",
    value: "Settings/UserOperations/EditUser.vue",
  },
  {
    text: "System Users",
    value: "Settings/UserOperations/UserList.vue",
  },
  {
    text: "User Groups",
    value: "Settings/UserOperations/UserGroups.vue",
  },
  {
    text: "System Settings",
    value: "Settings/SystemSettings/SystemSettings.vue",
  },
  {
    text: "System Setting",
    value: "Settings/SystemSettings/SystemSetting.vue",
  },
  {
    text: "Media Management",
    value: "Settings/Media/MediaManagement.vue",
  },
  {
    text: "Widgets",
    value: "Settings/Widgets/Widgets.vue",
  },
  {
    text: "Edit Widget",
    value: "Settings/Widgets/EditWidget.vue",
  },
  {
    text: "Add New Widget",
    value: "Settings/Widgets/NewWidget.vue",
  },
  {
    text: "Modules List",
    value: "Settings/Modules/ModulesList.vue",
  },
  {
    text: "Developer Tools",
    value: "Settings/Developer/DeveloperIndex.vue",
  },
  {
    text: "Developer Roles",
    value: "Settings/Developer/DeveloperRoles.vue",
  },
  {
    text: "Developer Widgets",
    value: "Settings/Developer/DeveloperWidgets.vue",
  },
  {
    text: "Developer Options",
    value: "Settings/Developer/DeveloperOptions.vue",
  },
  {
    text: "Developer Routers",
    value: "Settings/Developer/DeveloperRouters.vue",
  },
  {
    text: "Modular Workshop",
    value: "Settings/Developer/DeveloperModules.vue",
  },
  /**
   * Modules Views
   */
  {
    text: "Add New Product",
    value: "Modules/Urunler/UrunEkle.vue",
  },
  {
    text: "Urunler Categories",
    value: "Modules/Urunler/UrunCategories.vue",
  },
  {
    text: "Urun Detail",
    value: "Modules/Urunler/UrunDetail.vue",
  },
  {
    text: "Urun List",
    value: "Modules/Urunler/UrunList.vue",
  },
  {
    text: "Urun Listeleri",
    value: "Modules/Urunler/UrunListeleri.vue",
  },
  {
    text: "Urun Türleri",
    value: "Modules/Urunler/UrunAreas/UrunTurleri.vue",
  },
  {
    text: "Urun Özellikleri",
    value: "Modules/Urunler/UrunAreas/UrunOzellikleri.vue",
  },
  {
    text: "Urun Nitelikleri",
    value: "Modules/Urunler/UrunAreas/UrunNitelikler.vue",
  },
  {
    text: "Urun Seçenekleri",
    value: "Modules/Urunler/UrunAreas/UrunSecenekleri.vue",
  },
  {
    text: "Kullanicilar Listesi",
    value: "Modules/Kullanicilar/KullaniciList.vue",
  },
  {
    text: "Siparis List",
    value: "Modules/Siparisler/SiparisList.vue",
  },
  {
    text: "Sayfa Listesi",
    value: "Modules/Sayfalar/SayfaListesi.vue",
  },
  {
    text: "Sayfa Detay",
    value: "Modules/Sayfalar/SayfaDetay.vue",
  },
  {
    text: "Yazıların Listesi",
    value: "Modules/Yazilar/YaziListesi.vue",
  },
  {
    text: "Yazı Kategorileri",
    value: "Modules/Yazilar/YaziKategorileri.vue",
  },
  {
    text: "Yazı Detay",
    value: "Modules/Yazilar/YaziDetay.vue",
  },
  {
    text: "Slider Listesi",
    value: "Modules/Slider/SliderListesi.vue",
  },
  {
    text: "Slider Detay",
    value: "Modules/Slider/SliderDetay.vue",
  },
  {
    text: "İstatistikler",
    value: "Modules/Istatistikler/IstatistikDetay.vue",
  },
  {
    text: "Destek Talepleri",
    value: "Modules/Destek/DestekTalepleri.vue",
  },
  {
    text: "İletişim",
    value: "Modules/Iletisim/MesajListesi.vue",
  },
  {
    text: "TeklifMesajları",
    value: "Modules/Iletisim/TeklifMesajları.vue",
  },
  {
    text: "Toplu Mail",
    value: "Modules/TopluMail/TopluMailEditor.vue",
  },
  {
    text: "Stok Listesi",
    value: "Modules/Stok/StokListesi.vue",
  },
  {
    text: "Stok Depoları",
    value: "Modules/Stok/StokDepolar.vue",
  },
  {
    text: "Stok Satışları",
    value: "Modules/Stok/StokSatislar.vue",
  },
];

export default routes;